import Vue from 'vue'
export default {
	namespaced: true,
	state: {
		localBuy: [],
		localRent: [],
		localRentCountMonth: [],
		rent: [],
		buy: [],
		delivery: 5000,

		localFavorite: [],
	},
	getters: {
		localFavorite(state){
			return state.localFavorite;
		},

		localBuy(state){
			return state.localBuy;
		},
		localRent(state){
			return state.localRent;
		},
		localAllLength(state){
			return state.localBuy.length + state.localRent.length;
		},
		rentLength(state){
			return state.rent.length;
		},
		buyLength(state){
			return state.buy.length;
		},
		allLength( state, getters){
			return getters.rentLength + getters.buyLength;
		},
		rentComputed(state){
			return state.rent.map( item => {
				let rentItem = Object.assign({}, {}, item);
				let rent = rentItem.rent;
				for (let key in rentItem.rentDiscount) {
					if (parseInt(rentItem.monthCount) >= key) {
						rent = rentItem.rentDiscount[key];
					}
				}
				rentItem.computedRent = parseInt(rentItem.monthCount) * parseInt(rent);

				return rentItem;
			})
		},
		allSumm( state, getters ){
			let summ = 0;
			getters.rentComputed.forEach( item => {
				summ += parseInt( item.computedRent );
			});
			state.buy.forEach( item => {
				if (item.priceDiscount) {
					summ += parseInt( item.priceDiscount );
				} else {
					summ += parseInt( item.price );
				}
			});
			return summ;
		},
	},
	mutations: {
		set(state, [name, value]){
			state[name] = value;
		},
		addTo(state, value){
			if (state[value.type].indexOf(value.item) < 0){
				state[value.type].push(value.item);
			}
		},
		addCountMonth(state, value) {
			state[value.type].push({
				id: value.id,
				countMonth: value.countMonth
			});
		},
		deleteFrom(state, value){
			let index = state[value.type].indexOf(value.item);
			if (index >= 0){
				state[value.type].splice(index, 1)
			}
		},
		toogleItem(state, value){
			let index = state[value.type].indexOf(value.item);
			if (index < 0){
				state[value.type].push(value.item);
			} else {
				state[value.type].splice(index, 1);
			}
		},
		setRentMounthCount(state, item){
			state.rent[item.i].monthCount = item.value;
		},
		deleteItemIndex(state, value){
			state[value.type].splice(value.i, 1);
		},
		deleteItemId(state, value){
			state[value.type].forEach((item, index)=>{
				if (item.id ){
					if(item.id  === value.id){
						state[value.type].splice(index, 1);
					}
				} else {
					if(item  === value.id){
						state[value.type].splice(index, 1);
					}
				}
			})
		},
	},
	actions: {
		moveTo({ commit }, value){
			commit('addTo', {type: value.to, item: value.item});
			commit('deleteItemIndex', {type: value.from, i: value.i});
		},
		clearCart ({ commit }) {
			commit('set', ['localRent', []]);
			commit('set', ['localBuy', []]);
			commit('set', ['localRentCountMonth', []]);
			commit('set', ['rent', []]);
			commit('set', ['buy', []]);
		}
	}
};


// WEBPACK FOOTER //
// ./src/store/modules/cart.js